import { render, staticRenderFns } from "./CommonPdfReader.vue?vue&type=template&id=4de553af&scoped=true"
import script from "./CommonPdfReader.vue?vue&type=script&lang=js"
export * from "./CommonPdfReader.vue?vue&type=script&lang=js"
import style0 from "./CommonPdfReader.vue?vue&type=style&index=0&id=4de553af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de553af",
  null
  
)

export default component.exports